import Vue from 'vue'
import Router from 'vue-router'
// import cover from '../view/cover.vue'
import Index from '../view/Index.vue'
import Product from '../view/Product.vue'
import ProductInfo from '../view/ProductInfo.vue'
import Company from '../view/Company.vue'
import Application from '../view/Application.vue'
import Service from '../view/Service.vue'
import News from '../view/News.vue'
import NewsInfo from '../view/NewsInfo.vue'
import Contact from '../view/Contact.vue'

// import cover_m from '../view_mob/cover.vue'
import Index_m from '../view_mob/Index.vue'
import Product_m from '../view_mob/Product.vue'
import ProductInfo_m from '../view_mob/ProductInfo.vue'
import Company_m from '../view_mob/Company.vue'
import Application_m from '../view_mob/Application.vue'
import Service_m from '../view_mob/Service.vue'
import Faq_m from '../view_mob/Faq.vue'
import News_m from '../view_mob/News.vue'
import NewsInfo_m from '../view_mob/NewsInfo.vue'
import Contact_m from '../view_mob/Contact.vue'

Vue.use(Router)

const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const routes = [
    { path: '/',name: "App",component: Index },
    { path: '/Index',name: "Home",component: Index },
    { path: '/Product',name: "Product",component: Product },
    { path: '/ProductInfo',name: "ProductInfo",component: ProductInfo },
    { path: '/Company',name: "Company",component: Company },
    { path: '/Application',name: "Application",component: Application },
    { path: '/Service',name: "Service",component: Service },
    { path: '/News',name: "News",component: News },
    { path: '/NewsInfo',name: "NewsInfo",component: NewsInfo },
    { path: '/Contact',name: "Contact",component: Contact },

    { path: '/m/',name: "/m/App",component: Index_m },
    { path: '/m/Index',name: "/m/Home",component: Index_m },
    { path: '/m/Product',name: "/m/Product",component: Product_m },
    { path: '/m/ProductInfo',name: "/m/ProductInfo",component: ProductInfo_m },
    { path: '/m/Company',name: "/m/Company",component: Company_m },
    { path: '/m/Application',name: "/m/Application",component: Application_m },
    { path: '/m/Service',name: "/m/Service",component: Service_m },
    { path: '/m/Faq',name: "/m/Faq",component: Faq_m },
    { path: '/m/News',name: "/m/News",component: News_m },
    { path: '/m/NewsInfo',name: "/m/NewsInfo",component: NewsInfo_m },
    { path: '/m/Contact',name: "/m/Contact",component: Contact_m },
]
const router = new Router({
    mode: 'history',
    routes, // (缩写) 相当于 routes: routes
    scrollBehavior(to,from,savedPosition){
        if (savedPosition){
            return savedPosition // 按下 后退/前进 按钮时，类似浏览器的原生表现
        }else {
            return {x:0,y:0} // 让页面滚动到顶部
        }
    }
})
export default router;